import React, { useState, useEffect, memo } from "react";
import "./ContactBanner.css";
import Modal from "../../../Pages/ModalForm";
import HeadingH1 from "../../../utls/HeadingH1";
const ContactBanner = ({ onLoad }) => {
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [useHighRes, setUseHighRes] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Check network speed and update state accordingly.
  useEffect(() => {
    if (navigator.connection) {
      const connection = navigator.connection;
      // You can adjust the threshold as needed.
      if (connection.downlink && connection.downlink > 2) {
        setUseHighRes(true);
      }
    } else {
      // If navigator.connection is not available, assume a fast connection.
      setUseHighRes(true);
    }
  }, []);

  // Immediately unlock the rest of the page as soon as the banner mounts after delay of 0.5s.
  useEffect(() => {
    if (!useHighRes && onLoad) {
      const timer = setTimeout(() => {
        onLoad();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [useHighRes, onLoad]);

  // Callback for when the index 0 image loads on high-speed connections.
  const handleImageLoad = () => {
    if (useHighRes) {
      setImageLoaded(true);
      if (onLoad) {
        onLoad();
      }
    }
    if (!useHighRes) {
      const timer = setTimeout(() => {
        onLoad();
      }, 500);
      return () => clearTimeout(timer);
    }
  };

  return (
    <div
      className="banner-section banner-visible container-fluid contact-banner position-relative p-0"
      // For high-speed connections, temporarily remove min-height before image loads.
      style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
    >
      <img
        src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/1.%20contact.webp"
        alt="Contact Banner"
        className="w-100"
        // For high-speed, use eager loading; for low-speed, lazy loading.
        loading={useHighRes ? "eager" : "lazy"}
        // Attach the onLoad handler only for high-speed connections.
        onLoad={handleImageLoad}
        fetchpriority={useHighRes ? "high" : "auto"}
      />
      {imageLoaded ? (
        <>
          <div className="contact-text position-absolute text-white mt-2 mt-lg-5 pt-xxl-5">
            <p className="fs4 text-uppercase busy grotesk-headings">
              FREQUENT FLYER?
            </p>
            <HeadingH1 className="banner-headings">Ready to Assist you, Anytime</HeadingH1>
            <div className="d-flex common-second-content">
              <div className="ornge-border"></div>
              <div className="second-content w-75">
                Looking for ideal business travel solutions? Worry not, we are
                here to assist you 24/7 with expert guidance and trouble-free
                flight, hotel, or cab bookings.
              </div>
            </div>
            <div className="contactbtn mt-md-3 mt-xxl-5">
              <button
                className="btn fs4 fw-bold bg-transparent text-white text-uppercase leeter"
                type="submit"
                onClick={handleShow}
              >
                REACH OUT TODAY
              </button>
            </div>
            <Modal show={showModal} handleClose={handleClose} />
          </div>
        </>
      ) : null}
    </div>
  );
};

export default memo(ContactBanner);
